import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import type { Components } from "react-markdown";
import BackTraceIcon from "@/sections/WebSummary/BackTrace/BackTraceIcon";
import { hasUnpairedDoubleAsterisks } from "./util";
import "./index.less";

interface MarkdownRendererProps {
  content: string;
  components?: Record<string, React.ComponentType>;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
  content,
  components = {},
}) => {
  const [showContent, setShowContent] = useState(content);

  useEffect(() => {
    const hasUnpaired = hasUnpairedDoubleAsterisks(content || "");
    // 单独以-结尾的，会使标题字体变大，不进行预览
    // 有未闭合的**，不进行预览
    if (!content?.endsWith("-") && !hasUnpaired) {
      setShowContent(content);
    }
  }, [content]);

  const defaultComponents = {
    contentbacktraceicon: ({
      index,
      item,
    }: {
      index: number;
      item: string;
    }) => (
      <BackTraceIcon
        module={`contentBackTrace`}
        index={Number(index)}
        item={item}
        className="ml-2.5"
      />
    ),
  };

  return (
    <div className="vditor">
      <div className="vditor-reset">
        <ReactMarkdown
          components={{ ...defaultComponents, ...components } as Partial<Components>}
          rehypePlugins={[rehypeRaw]}
        >
          {showContent}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default MarkdownRenderer;
